import { render, staticRenderFns } from "./TourTerms.vue?vue&type=template&id=9df8d18a&scoped=true&"
import script from "./TourTerms.vue?vue&type=script&lang=js&"
export * from "./TourTerms.vue?vue&type=script&lang=js&"
import style0 from "./TourTerms.vue?vue&type=style&index=0&id=9df8d18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df8d18a",
  null
  
)

export default component.exports